import {useApp} from "@/js/app.js";
import Guest from "@/js/Views/Guest.vue";
import Router from "@/js/Plugins/Router.js";
import LoginView from '@/js/Views/Auth/Index.vue';
import LoginForm from '@/js/Views/Auth/Login/Index.vue';
import ResetPassword from '@/js/Views/Auth/ResetPassword/Index.vue';
import PasswordReminder from '@/js/Views/Auth/PasswordReminder/Index.vue';
import Registration from '@/js/Views/Auth/Registration/Index.vue';

const setup = window.setup;
useApp(Guest, setup)
    .use(Router,{
        public: true,
        routes: [
            {
                path: '/auth',
                name: 'auth',
                component: LoginView,
                children: [
                    {
                        path: 'login',
                        name: 'auth.login',
                        component: LoginForm,
                    }, {
                        path: 'password/reset/:token',
                        name: 'auth.reset-password',
                        component: ResetPassword
                    },{
                        path: 'password-reminder',
                        name: 'auth.password-reminder',
                        component: PasswordReminder
                    }, {
                        path: 'registration',
                        name: 'auth.registration',
                        component: Registration
                    }
                ]
            },
        ]
    }).mount('#app');